module.exports = __webpack_public_path__ + "img/ban_8.75a4e8c1.png";